var React = require('react');
const { withTranslation } = require('react-i18next');
const { useState } = require('react');
const { canSwapOnHover } = require('./metricHoverHelpers');

const FieldDetailsMetricBox = ({
  label,
  value,
  unit,
  fieldState,
  lastSeen,
  onHover,
  onHoverLabel,
  hoverCondition,
  appearWithEmptyValue,
  stacked,
  t,
}) => {
  const [isHover, setIsHover] = useState(false);

  if (
    !appearWithEmptyValue &&
    (value === '' || value === null || value === undefined)
  )
    return null;

  let spanStyle =
    fieldState === 'active'
      ? 'text-blue-secondary font-weight-bold '
      : 'text-grey71 font-weight-bold';
  let paddingStyle = fieldState === 'active' ? 'pl-4 pr-4' : 'pl-5 pr-5';

  let lastSeenStyle = 'text-blue-secondary font-weight-normal text-size-12';
  let divsStyle =
    fieldState === 'active'
      ? 'text-grey45 text-truncate text-size-14'
      : 'text-grey71 text-truncate text-size-14';

  if (stacked) {
    // Farm View strip cell: sized by its content (Figma "data cell").
    const cellClassName = `field-details-metric--stacked ${
      fieldState === 'active' ? '' : 'field-details-metric--archive'
    }`;
    const renderPair = (pairLabel, pairValue) => (
      <>
        <span className='field-details-metric__label'>{t(pairLabel)}</span>
        <span className='field-details-metric__value'>
          {pairValue} {unit}
          {lastSeen && (
            <span className='field-details-metric__last-seen'>
              {' (' + t(lastSeen[1]).format(lastSeen[0]) + ')'}
            </span>
          )}
        </span>
      </>
    );

    // Hover swap (e.g. Kc → Kc optimized), as in the Field View. The cell
    // resizes to the hovered pair, so the cells after it shift while hovered.
    // Hover is tracked whenever the metric has a hover (hoverCondition), not
    // only while it can swap: the cell keeps its state across field switches,
    // and onHover can be empty on one field, so a leave missed there would
    // leave it stuck on the swap. Metrics without a hover don't track it.
    const swappable = canSwapOnHover({ hoverCondition, onHover });
    return (
      <div
        className={cellClassName}
        onMouseEnter={hoverCondition ? () => setIsHover(true) : undefined}
        onMouseLeave={hoverCondition ? () => setIsHover(false) : undefined}
      >
        {swappable && isHover
          ? renderPair(onHoverLabel, onHover)
          : renderPair(label, value)}
      </div>
    );
  }

  return (
    <div
      className={`text-center flex-grow-1 d-flex align-items-center justify-content-center ${paddingStyle}`}
      style={{
        borderLeft: '0.5px solid #DCE0E8',
        borderBottom: '0.5px solid #DCE0E8',
        minWidth: hoverCondition ? '188px' : 'auto',
      }}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className={divsStyle}>
        {hoverCondition && isHover ? t(onHoverLabel) : t(label)}{' '}
        <span
          className={`p-1 pr-2 ${spanStyle}`}
          style={{ borderRadius: '5px' }}
        >
          {hoverCondition && isHover ? onHover : value} {unit}
          {lastSeen && (
            <span className={lastSeenStyle}>
              {' '}
              {' (' + t(lastSeen[1]).format(lastSeen[0]) + ')'}
            </span>
          )}
        </span>
      </div>
    </div>
  );
};

module.exports = withTranslation()(FieldDetailsMetricBox);
